import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Button from "../components/button"

class Projects extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Projects" />
        <div className="projects">
          <h2>Projects</h2>

          <h3 id="solar-equity-index">Solar Equity Index</h3>
          <p>The <strong>Solar Equity Index</strong> is an end-to-end data project created for Terra.do's Software for Climate course (Feb '26 Cohort) that identifies where rooftop solar investment would have the greatest equity impact across NYC and LA neighborhoods. A Python pipeline pulls from public APIs and datasets to score every census tract on solar potential, energy cost burden, and adoption gap (producing an index that is 94.6% independent of income).</p>
          <p>The pipeline feeds directly into a Next.js web app that lets anyone explore all ~4.6k scored tracts via interactive map across both cities, drill into the three-signal breakdown behind any tract's score, and surface the top equity-priority neighborhoods through a filter that ensures high-opportunity tracts reflect genuine need (rather than just wealthy neighborhoods with good rooftops).</p>
          <p>Demo: <a href="https://solarequityindex.netlify.app" target="blank">https://solarequityindex.netlify.app</a></p>
          <p>Hex notebook: <a href="https://app.hex.tech/019c3142-a571-7001-b4d4-2e78d9bb0fb5/app/032vAGLT3QkeBrZNADLmto/latest" target="blank">https://app.hex.tech/019c3142-a571-7001-b4d4-2e78d9bb0fb5/app/032vAGLT3QkeBrZNADLmto/latest</a></p>
          <p>GitHub Repo: <a href="https://github.com/andytron/solar-equity-index" target="blank">https://github.com/andytron/solar-equity-index</a></p>
          <p>Presentation deck: <a href="https://docs.google.com/presentation/d/1-oQKMQBmU5vadyNCOvxds2vSUGQRk7YGPr4wE4t7jPM/edit?usp=sharing" target="blank">https://docs.google.com/presentation/d/1-oQKMQBmU5vadyNCOvxds2vSUGQRk7YGPr4wE4t7jPM/edit?usp=sharing</a></p>

          <Link to="/">
            <Button marginTop="85px">Go Home</Button>
          </Link>
        </div>
      </Layout>
    )
  }
}

export default Projects

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
